export default __webpack_public_path__ + "static/media/gallery_06.dd162190.jpg";